import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';

// eslint-disable-next-line import/prefer-default-export
export const ColStyled = styled(Col)`
  text-align: center;
  margin-bottom: ${rem(32)};
`;